<template>
  <div class="action-sheet">
    <action-sheet
      v-model="show"
      :close-on-click-overlay="false"
    >

      <div class="content">
        <div class="sheet-header">
          <span>敬请阅读</span> <img @click="handleAgree" class="cancel_button"  data-sensors-click src="./btn_close@2x.png">
        </div>
        <h4>亲爱的天美贷平台用户，服务协议有更新哦！</h4>
        <p> 协议中有对您权利义务特别的约定以及管理约定等重要条款，请您务必仔细阅读。</p>
        <p class="mt30">如您继续使用我们的服务，表示您已充分阅读、理解并接受协议的全部内容，阅读协议的过程中，如果您有任何疑问，可向平台客服询问，当您点击同意并开始使用产品服务时，即表示你已理解并同意以下协议内容。</p>
        <ul>
          <li v-for="item in agreements" :key="item.url"><a :href="item.url">{{ item.name }}</a></li>
        </ul>
        <nd-button class="btn agreements_button" data-sensors-click @click="handleAgree">同意上述协议，继续使用平台服务</nd-button>
      </div>
    </action-sheet>
  </div>
</template>

<script>
import { ActionSheet } from 'vant'
export default {
  components: {
    ActionSheet
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    agreements: {
      type: Array,
      default: () => []
    },
    agreementVersion: {
      type: String,
      default: ''
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  mounted () {
    this.$sensors.track('Element_Exposure', { caseId: 'agreementsUpdate' })   
  },
  methods: {
    receiveShowListPop (items) {
      this.$emit('needsShowListPop', items)
    },
    confirmApply (items) {
      this.$refs.apiPage.receiveApplyAction(items)
    },
    handleAgree () {
      localStorage.setItem('agreementVersion', this.agreementVersion)
      this.$emit('on-agree')
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.action-sheet {
  .sheet-header {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 36px;
    color: #333333;
    line-height: 50px;
    text-align: left;
    font-style: normal;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 24px;
    }
  }

  .content {
    padding: 50px 30px;
    font-family: PingFangSC, PingFang SC;
    font-size: 26px;
    line-height: 37px;
    text-align: justify;
    h4 {
      color: #333333;
      margin-top: 24px;
    }
    p {
      color: #666;
    }
    .mt30 {
      margin-top: 30px;
    }
    ul {
      padding: 30px 0;
      margin-bottom: 30px;
      li {
        a {
          padding: 10px 0;
          display: block;
          color: #8EB2D8;
        }
      }
    }
    .btn {
      margin: auto;
    }
  }
}
</style>